import React, { useEffect, useRef } from "react";
import "./SortMenu.css";
import checkIcon from "../../assets/check.svg";

const SortMenu = ({
  isOpen,
  onClose,
  sortOrder,
  onSortChange,
  filterType,
  onFilterChange,
  position,
  isShowUnreplied,
  setIsShowUnreplied,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="sort-menu"
      ref={menuRef}
      style={{
        top: position?.top || 0,
        right: position?.right || 0,
      }}
    >
      <div
        className={`sort-menu-item ${sortOrder === "timecode" ? "active" : ""}`}
        onClick={() => onSortChange("timecode")}
      >
        <div className="sort-menu-item-content">
          {sortOrder === "timecode" && (
            <img src={checkIcon} alt="selected" className="check-icon" />
          )}
          <span>По таймкоду</span>
        </div>
      </div>
      <div
        className={`sort-menu-item ${sortOrder === "new" ? "active" : ""}`}
        onClick={() => onSortChange("new")}
      >
        <div className="sort-menu-item-content">
          {sortOrder === "new" && (
            <img src={checkIcon} alt="selected" className="check-icon" />
          )}
          <span>Сначала новые</span>
        </div>
      </div>
      <div
        className={`sort-menu-item ${sortOrder === "old" ? "active" : ""}`}
        onClick={() => onSortChange("old")}
      >
        <div className="sort-menu-item-content">
          {sortOrder === "old" && (
            <img src={checkIcon} alt="selected" className="check-icon" />
          )}
          <span>Сначала старые</span>
        </div>
      </div>
      <div className="sort-menu-divider"></div>
      <div
        className={`sort-menu-item ${
          filterType === "archived" ? "active" : ""
        }`}
        onClick={() =>
          onFilterChange(filterType === "archived" ? "all" : "archived")
        }
      >
        <div className="sort-menu-item-content">
          {filterType === "archived" && (
            <img src={checkIcon} alt="selected" className="check-icon" />
          )}
          <span>Показать решенные</span>
        </div>
      </div>
      <div
        className={`sort-menu-item ${isShowUnreplied ? "active" : ""}`}
        onClick={() => {
          setIsShowUnreplied(!isShowUnreplied);
          onClose();
        }}
      >
        <div className="sort-menu-item-content">
          {isShowUnreplied && (
            <img src={checkIcon} alt="selected" className="check-icon" />
          )}
          <span>Показать неотвеченные</span>
        </div>
      </div>
    </div>
  );
};

export default SortMenu;
